<template>
    <news-loader v-if="loading"></news-loader>
    <news-error v-else-if="error"></news-error>
    <div v-else>
        <news-results :results="results"></news-results>
    </div>
</template>

<script>
    import NewsLoader from "./news-loader";
    import NewsArticle from "./news-article";
    import NewsError from './news-error';
    import NewsResults from './news-results';

    export default {
        components: { NewsLoader, NewsArticle, NewsError, NewsResults },
        props: {
            loading: {
                type: Boolean,
                required: true,
            },
            results: {
                type: Array,
                required: true,
            },
            total: {
                type: Number,
                required: true,
            },
            error: {
                type: Error,
            }
        },
    }
</script>
